import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function SettingsFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.545 2c.325 0 .588.263.588.588v1.525c.428.119.842.273 1.239.458l.959-1.16a.588.588 0 01.835-.073l2.367 2.017a.588.588 0 01.072.822l-.969 1.172c.253.369.477.76.668 1.168l1.467-.262a.588.588 0 01.683.478l.537 3.09a.588.588 0 01-.476.68l-1.471.263c-.041.457-.12.904-.232 1.336l1.298.761a.588.588 0 01.214.799l-1.545 2.717a.588.588 0 01-.809.217l-1.292-.758a8.163 8.163 0 01-1.013.863l.516 1.439a.588.588 0 01-.35.75l-2.903 1.073a.588.588 0 01-.758-.353l-.512-1.428a7.916 7.916 0 01-1.316 0l-.512 1.428a.588.588 0 01-.758.354L7.17 20.89a.588.588 0 01-.35-.75l.516-1.439c-.361-.26-.7-.548-1.013-.863l-1.293.758a.589.589 0 01-.808-.217l-1.546-2.717a.588.588 0 01.214-.798l1.299-.762a8.254 8.254 0 01-.232-1.336l-1.471-.263a.588.588 0 01-.476-.68l.536-3.09a.588.588 0 01.684-.478l1.467.262c.191-.409.415-.8.667-1.168l-.968-1.172a.588.588 0 01.072-.822l2.367-2.017a.588.588 0 01.835.073l.959 1.16c.396-.185.81-.34 1.239-.458V2.588c0-.325.263-.588.588-.588h3.09zM12 8a4 4 0 100 8 4 4 0 000-8z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SettingsFill);
export default ForwardRef;